import React from 'react';
import PropTypes from 'prop-types';
import { formatText } from 'core/i18n';
import StringHelper from 'utilities/stringHelper';
import MessagesScreen from 'components/messagesScreen/messagesScreen';

const IdentityIbanFinishMessages = ({ identityIban, onHandleFinishIdentity }) => {
    return (
        <div className="main-container messages-main-container basic-layering">
            <MessagesScreen
                iconClass="icons icons--icon-checked"
                title={formatText('messagesScreen-ibanFinishTitle')}
                buttonText={formatText('button-continue')}
                showRoadmapNavigation={true}
                roadmapNavigationProps={{
                    buttonContinueAction: onHandleFinishIdentity,
                }}
            >
                {formatText('messagesScreen-ibanFinishInfo', [StringHelper.addSeparatorToIban(identityIban)])}
            </MessagesScreen>
        </div>
    );
};

IdentityIbanFinishMessages.propTypes = {
    identityIban: PropTypes.array,
    onHandleFinishIdentity: PropTypes.func.isRequired,
};
export default IdentityIbanFinishMessages;
